import { createContext, useContext } from 'react';
import { maybe } from '@passionware/monads';
import { AppScope } from '../appScope.types';
import {
  assertInitializedAppScope,
  InternalAppScope
} from './internalAppScope';

export const AppScopeContext = createContext<InternalAppScope | null>(null);

/** INTERNAL — AppScopeService.impl calls this; throws when scope is not initialized. */
export function useAppScopeFromContext(): AppScope {
  const scope = maybe.getOrThrow(
    useContext(AppScopeContext),
    'useAppScopeFromContext must be used within AppScopeProvider'
  );
  assertInitializedAppScope(scope);
  return scope;
}

/** Nested route wrappers only — parent org before inner AppScopeProvider. */
export function useParentOrganizationId(): string {
  return useAppScopeFromContext().organizationId;
}
